import * as React from 'react';
import { Typography } from '@material-ui/core';
import { Root, RouteList, ComparisonSearch } from '../containers';

const comparisonSearchPage: React.FC = () => {

  return (
    <Root routeList={<RouteList />}>
      <Typography variant="h4">
        契約文書の比較の結果
      </Typography>
      <ComparisonSearch />{/** ここでエラーになる場合は大抵containers/で定義が足りてない */}
    </Root>
  );
};

export default comparisonSearchPage;



// WEBPACK FOOTER //
// ./src/pages/comparisonsearch.tsx